export default __webpack_public_path__ + "images/plot-type-geo-bubble.7880c073346e5917f3368550df0208c3.svg";